/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ValidationType } from "../../records/types/ValidationType";
export const CompositeUniqueConstraintConfig = core.serialization.object({
    message: core.serialization.string().optional(),
    level: ValidationType.optional(),
});
